import { Endpoint, getFilterDates, IeAnexo, ToastServiceStipulator } from '@philips-emr/hpms-stipulator-commons';
import { DeckAPI, FilterAPI } from '@philips-emr/tws-components';
import Controller, { OnSelectItem, OnSubmit } from '@philips-emr/tws-core/lib/client';
import { SelectItemEvent, SubmitEvent } from '@philips-emr/tws-core/lib/component/types';
import { FileService, MessageService } from '@philips-emr/tws-core/lib/services';
import { HttpMethod } from '@philips-emr/tws-core/lib/services/http-service';

import { FolhasPagamentoAliases as Aliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

interface FolhaPagamento {
  nrSeqFolhaPagamento: number,
  nmArquivo: string,
}

@Controller({ fragment: FragmentNames.FOLHAS_PAGAMENTO })
export default class FolhasPagamentoController extends BaseController {

  @OnSubmit(Aliases.FILTER_FOLHAS_PAGAMENTO)
  onSubmitFilter(event: SubmitEvent): void {
    const { record, target } = event;

    const api = target as unknown as FilterAPI;

    if (record && record.dtInicio && record.dtFim) {
      return;
    }

    api.setData({});
    api.setData({ ...getFilterDates('dtInicio', 'dtFim', 12), ...api.getRecord() });
  }

  @OnSelectItem(Aliases.DECK_FOLHAS_PAGAMENTO)
  onClickDownloadDocumento(event: SelectItemEvent<any>): void {
    const { nrSeqFolhaPagamento, nmArquivo } = event.item as FolhaPagamento;
    const api = event.target as DeckAPI;
    api.unselectAll();
    this.downloadFolhaPagamentoAnexo(nrSeqFolhaPagamento, nmArquivo);
  }

  private downloadFolhaPagamentoAnexo = (nrSeqFolhaPagamento: number, nmArquivo: string): void => {
    const { nrSeqContrato } = this.historyService.getCurrentRouteParams();
    const ieTabela = IeAnexo.FOLHA_PAGAMENTO;

    FileService.download(Endpoint.GET.FOLHA_PAGAMENTO_DOWNLOAD, nmArquivo, { ieTabela, nrSeqFolhaPagamento, nrSeqContrato }, HttpMethod.GET)
      .catch(() => ToastServiceStipulator.error(MessageService.translate('stipulator.arquivo-nao-localizado')));

  };
}
